import React from 'react';

const PageScrollContext = React.createContext(null);
export const PageScrollProvider = PageScrollContext.Provider;

export const WithPageScrollProvider = ({ pageScroll, children }) => {
	const value = pageScroll.current || {};
	return <PageScrollProvider value={value}>{children}</PageScrollProvider>;
};
export default PageScrollContext;
